import { defaults } from './lib/defaults.js';
import { quiet_qrcode as qrcode } from './lib/qrcode.js';
import { create_canvas_qrcode } from './lib/create_canvas_qrcode.js';
import { create_svg_qrcode } from './lib/create_svg_qrcode.js';

export const kjua = options => {
    const settings = Object.assign({}, defaults, options);
    const qr = qrcode(settings.text, settings.ecLevel, settings.minVersion, settings.quiet);

    if (settings.render === 'svg') {
        return create_svg_qrcode(qr, settings);
    }
    return create_canvas_qrcode(qr, settings, settings.render === 'image');
};
